const filterListModalFilterEquip = {
  text: 'FILTERS',
  clear: 'clean filters'
};

export default filterListModalFilterEquip;
